var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8579_30967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.75H4V4.5C4 2.56953 5.56953 1 7.5 1H20.0508C20.9805 1 21.8719 1.36641 22.5281 2.02266L23.9773 3.47187C24.6336 4.12812 25 5.01953 25 5.94922V9.75H23.25V5.94922C23.25 5.48438 23.0641 5.04141 22.7359 4.71328L21.2867 3.26406C20.9586 2.93594 20.5156 2.75 20.0508 2.75H7.5C6.53203 2.75 5.75 3.53203 5.75 4.5V9.75ZM25 13.25H4C3.03203 13.25 2.25 14.032 2.25 15V22H4V20.25C4 19.282 4.78203 18.5 5.75 18.5H23.25C24.218 18.5 25 19.282 25 20.25V22H26.75V15C26.75 14.032 25.968 13.25 25 13.25ZM25 23.75V27.25C25 28.218 24.218 29 23.25 29H5.75C4.78203 29 4 28.218 4 27.25V23.75H2.25C1.28203 23.75 0.5 22.968 0.5 22V15C0.5 13.0695 2.06953 11.5 4 11.5H25C26.9305 11.5 28.5 13.0695 28.5 15V22C28.5 22.968 27.718 23.75 26.75 23.75H25ZM5.75 20.25V27.25H23.25V20.25H5.75ZM24.125 14.5625C24.4731 14.5625 24.8069 14.7008 25.0531 14.9469C25.2992 15.1931 25.4375 15.5269 25.4375 15.875C25.4375 16.2231 25.2992 16.5569 25.0531 16.8031C24.8069 17.0492 24.4731 17.1875 24.125 17.1875C23.7769 17.1875 23.4431 17.0492 23.1969 16.8031C22.9508 16.5569 22.8125 16.2231 22.8125 15.875C22.8125 15.5269 22.9508 15.1931 23.1969 14.9469C23.4431 14.7008 23.7769 14.5625 24.125 14.5625Z",
    fill: "#302B29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8579_30967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.84831b6baa30d56c9bd8898694e50fef.svg";
export { ForwardRef as ReactComponent };